// extracted by mini-css-extract-plugin
export default {"input":"SearchBar_input__bIy50"};